import { render, staticRenderFns } from "./ChatMainFeedPost.vue?vue&type=template&id=238cd276&scoped=true"
import script from "./ChatMainFeedPost.vue?vue&type=script&lang=js"
export * from "./ChatMainFeedPost.vue?vue&type=script&lang=js"
import style0 from "./ChatMainFeedPost.vue?vue&type=style&index=0&id=238cd276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238cd276",
  null
  
)

export default component.exports